import React from 'react';
import NavigationRoutes from '../navigation/NavigationRoutes';

const Main = () => {
  return (
    <main>
      <NavigationRoutes />
    </main>
  );
};

export default Main;
